"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu, type MenuItem } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuList({
  items,
  level = 0
}: {
  items: MenuItem[];
  level?: number;
}) {
  return <ul className={level === 0 ? "space-y-3.5" : "space-y-2 mt-2 pl-3 border-l border-[hsl(222,25%,22%)]"}>
      {items.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[hsl(40,20%,75%)] hover:text-[hsl(173,70%,45%)] transition-colors text-sm font-default block">
            {item.label}
          </Link>
          {item.children && item.children.length > 0 && <FooterMenuList items={item.children} level={level + 1} />}
        </li>)}
    </ul>;
}
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3.5">
        <div className="h-4 w-24 bg-[hsl(222,25%,20%)] animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-[hsl(222,25%,20%)] animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-[hsl(222,25%,20%)] animate-pulse rounded-md" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3.5">
        <li data-index={0}>
          <Link to="/HomePage" className="text-[hsl(40,20%,75%)] hover:text-[hsl(173,70%,45%)] transition-colors text-sm font-default block">
            Guida Prezzi 2026
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/chi-siamo/" className="text-[hsl(40,20%,75%)] hover:text-[hsl(173,70%,45%)] transition-colors text-sm font-default block">
            Chi Siamo
          </Link>
        </li>
      </ul>;
  }
  return <FooterMenuList items={menuItems} />;
}
export default function Footer() {
  return <section data-section-id="252275" id="footer" className="bg-[hsl(222,47%,8%)] text-[hsl(40,30%,97%)] pt-20 pb-12 lg:pt-28 lg:pb-16 border-t border-[hsl(222,25%,20%)]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 mb-16">
          {/* Brand Col */}
          <div className="flex flex-col items-start space-y-4">
            <p className="text-[hsl(40,20%,75%)] text-sm max-w-xs font-default leading-relaxed">
              Guida agli Impianti Dentali in Albania
            </p>
          </div>

          {/* Quick Links Col */}
          <div>
            <h3 className="font-default font-semibold text-[hsl(40,30%,97%)] mb-6 uppercase tracking-wider text-xs">
              Link Rapidi
            </h3>
            <MenuProvider menu_id="51">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {/* Legal Notes Col */}
          <div>
            <h3 className="font-default font-semibold text-[hsl(40,30%,97%)] mb-6 uppercase tracking-wider text-xs">
              Note Legali
            </h3>
            <ul className="space-y-3.5 mb-8">
              <li data-index={0}>
                <Link to="https://impiantidentali.co/privacy-policy/" className="text-[hsl(40,20%,75%)] hover:text-[hsl(173,70%,45%)] transition-colors text-sm font-default block">
                  Privacy Policy
                </Link>
              </li>
              <li data-index={1}>
                <Link to="https://impiantidentali.co/cookie-policy/" className="text-[hsl(40,20%,75%)] hover:text-[hsl(173,70%,45%)] transition-colors text-sm font-default block">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-[hsl(222,25%,20%)] mb-10" />

        {/* Disclaimer & Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <p className="text-[hsl(40,20%,70%)] text-[12px] leading-relaxed max-w-3xl font-default">
            Guida informativa realizzata con SkyDental Tirana. Le informazioni non sostituiscono il parere di un professionista sanitario qualificato.
          </p>
          <p className="text-[hsl(40,20%,55%)] text-[12px] shrink-0 font-default">
            © 2026 ImpiantiDentali.co – Guida realizzata con SkyDental Tirana
          </p>
        </div>
      </div>
    </section>;
}